import { ProjectSchemaImpl } from "./project-schema.js";
export class UserSchema extends ProjectSchemaImpl {
    constructor(userSchema, layers = {}) {
        super(userSchema, layers);
    }
    static fromJson(runtimeSchema, layers) {
        return new UserSchema(runtimeSchema, layers);
    }
}
